module.exports = __webpack_public_path__ + "static/media/Artboard8.efa3b8f9.png";